import axios from 'axios'
import Api from '@/api.js'

const STAxios = axios.create({
  baseURL: Api.st_config.API_BASE_URL
})

export const getAuthHeader = (token) => {
  let authHeader = ''

  if (Api.uat_token) {
    authHeader = 'UAT ' + Api.uat_token
  } else {
    authHeader = 'JWT ' + token
  }

  return authHeader
}

export default {

  getSTAxios: function () {
    return STAxios
  },

  setSTAuthToken: function (token) {
    STAxios.defaults.headers.Authorization = getAuthHeader(token)
  },

  deleteSTAuthToken: function () {
    delete STAxios.defaults.headers.Authorization
  },
  initAxiosInterceptor: function (store) {
    STAxios.interceptors.response.use(
      (response) => response,
      async (error) => {
        const request = error.config
        if (error.response && error.response.status === 401 && !request._retry) {
          request._retry = true

          if (!store.getters.isRefreshingToken) {
            store.dispatch('setIsRefreshingToken', true)

            window.parent.postMessage({ type: 'tokenUpdateRequested' }, '*')

            return new Promise((resolve, reject) => {
              store.dispatch('addPendingRequest', { resolve, reject })
            }).then((token) => {
              request.headers.Authorization = getAuthHeader(token)
              return STAxios(request)
            }).finally(() => {
              store.dispatch('setIsRefreshingToken', false)
              store.dispatch('resetPendingRequest')
            })
          } else {
            return new Promise((resolve, reject) => {
              store.dispatch('addPendingRequest', { resolve, reject })
            }).then((token) => {
              request.headers.Authorization = getAuthHeader(token)
              return STAxios(request)
            })
          }
        }

        return Promise.reject(error)
      }
    )
  }

}
